import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from '/src/images/home';
import { DriverCooler, Mount360, DriverMountMobile } from '/src/images/home';

const HandsFree = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.hands-free' });

	return (
		<section id="hands-free">
			<div>
				<section>
					<aside>
						<h3>{t('your-hands-free')}</h3>
					</aside>

					<aside>
						<p>
							{t('getting-started-with')}&nbsp;
							<span className="bold">{t('note-make-sure')}</span>
						</p>
					</aside>
				</section>

				<section>
					<aside>
						<h4>{t('byom')}</h4>

						<p>
							<span className="bold">{t('bring-your-own')}</span>
							&nbsp;{t('get-started-with')}
						</p>
					</aside>

					<aside>
						<img src={Mount360} className="desktop-screen" alt={t('three-sixty-degree')} />
						<img src={DriverMountMobile} className="mobile-screen" alt={t('three-sixty-degree')} />
					</aside>
				</section>

				<section>
					<aside>
						<h4 className="driver-cooler">
							{t('driver')}<span className="light">{t('cooler')}</span>
						</h4>

						<p>{t('in-hot-climates')}</p>
						<p className="hide">{t('get-fifteen-of')} <img src={InfoIcon} alt={t('more-information')} /></p>
						<p>{t('works-best-with')}</p>

						<a
							href="https://www.amazon.com/Driver-DRIVER-App-Car-Phone-Holder-Mount-Cooling-Rotation-Dashboard-Windshield-Compatible/dp/B0B52NFD63?ref_=ast_sto_dp"
							target="_blank"
							rel="noreferrer">
							<button>{t('buy-the-driver-cooler')}</button>
						</a>
					</aside>

					<aside>
						<img src={DriverCooler} alt={t('driver-cooler-mount')} />
					</aside>
				</section>
			</div>
		</section>
	);
};

export default HandsFree;
